import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Constants } from '@utils/constants';
import { AuthServer } from '@services/auth-server.service';
import { ContextInfoUser } from '@model/webFeeder/context-info-user';
import { AppUtils } from '@utils/app.utils';
import { AuthenticationService } from '@services/authentication.service';
import { LoginDuplicatedEnum } from '@model/enum/login-duplicated.enum';
import { ScktLoginDuplicatedService } from '@services/webFeeder/sckt-login-duplicated.service';
import { AuthService } from '@auth/auth.service';
import { SocketService } from '@services/webFeeder/socket.service';
import { CustomSnackbarService } from '@services/custom-snackbar-service.service';
import { MultiBrokerLoginTypesEnum } from '@model/enum/multibroker-type-enum';
import { WhitelabelBrokerEnum } from '@model/enum/whitelabel-broker.enum';

@Component({
  selector: 'app-auth-broker',
  templateUrl: './auth-broker.component.html'
})
export class AuthBrokerComponent implements OnInit, OnDestroy {

  @ViewChild('snackBar', { read: ViewContainerRef }) parent: ViewContainerRef;

  title = 'Autenticar com sua corretora';
  subTitle = '';

  titleExpiredPassword = Constants.LOGIN_EXPIRED_PASSWORD;
  subTitleExpiredPassword = '';

  titleForgotPassword = 'Recupere o seu usuário e senha da corretora.';
  subTitleForgotPassword = 'Preencha o quadro abaixo com as informações solicitadas. Enviaremos seu usuário e senha de negociação para o seu e-mail.';

  loading: boolean;

  isForgotPassword: boolean;
  isResetPassword: boolean;
  multiBrokerloginType: number;
  msgErrorCustom: string;

  brokeragePartners = [];
  multiBrokerSelected: any = [];
  multiBrokerTypes = Constants.MULTI_BROKER_TYPES_RADIO;

  authForm: FormGroup;
  forgotForm: FormGroup;
  resetForm: FormGroup;
  model = [];
  typeRadioSelected: any;
  passwordComplexyLength: boolean;
  passwordComplexySpecial: boolean;
  passwordComplexyNumber: boolean;
  passwordComplexyLetterUp: boolean;
  passwordComplexyLetterDown: boolean;
  showpassword = false;
  showPasswordConfirm = false;
  brokerConnected: any;
  isAuthenticationBroker: boolean;
  showNotification: boolean;
  isNotificationError: boolean;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<AuthBrokerComponent>,
    private _formBuilder: FormBuilder,
    private _configService: ConfigService,
    private _authServer: AuthServer,
    private _authenticationService: AuthenticationService,
    private _scktLoginDuplicatedService: ScktLoginDuplicatedService,
    private _authService: AuthService,
    private _socket: SocketService,
    public _snackBar: CustomSnackbarService,
  ) { }

  ngOnInit() {
    this.buildForm();
    this.multiBrokerloginType = MultiBrokerLoginTypesEnum.MULTIBROKER;
    this.brokerConnected = this._configService.getBrokerConnected();
    this.isAuthenticationBroker = this._configService.isAuthenticationBroker();
    this.selectTypeConnection(this.multiBrokerloginType);
  }

  ngOnDestroy() {
    const brokerSelected = this._configService.getConfigMultibroker();
    this._configService.removeStopValidUser();
    if ((this.brokerConnected && brokerSelected && this.brokerConnected !== brokerSelected.usersBrokerName) || !this.isAuthenticationBroker) {
      this.removeConfigMultibroker();
    }
  }

  closeClick(): void {
    this.dialogRef.close();
  }

  removeConfigMultibroker() {
    this._configService.deleteConfigMultibroker();
  }

  buildForm() {
    const userNameTemp = this._configService.isAuthenticationBroker ? this._configService.getBrokerAccount() : '';
    this.authForm = this._formBuilder.group({
      username: new FormControl(userNameTemp, [Validators.required, Validators.minLength(3), Validators.nullValidator]),
      password: new FormControl('', [Validators.required, Validators.minLength(3)]),
      broker: new FormControl('', [Validators.required]),
    });
    this.resetForm = this._formBuilder.group({
      password: new FormControl('', [Validators.required, Validators.minLength(3)]),
      newPassword: new FormControl('', [Validators.required, Validators.minLength(3)]),
    });
    this.forgotForm = this._formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  selectTypeConnection(id) {
    if (id >= 0) {
      this.multiBrokerloginType = id;
    }
    this.typeRadioSelected = this.multiBrokerTypes.find(x => x.type === id);
    if (this.typeRadioSelected) {
      this.subTitle = this.typeRadioSelected.tooltip;
      if (this.multiBrokerloginType === MultiBrokerLoginTypesEnum.MULTIBROKER) {
        this.getContextInfoUser();
      }
    }
  }

  send() {
    this.loading = true;
    if (this.isForgotPassword && this.forgotForm.status === 'VALID') {
      this.forgotPassword();
    } else if (this.isResetPassword && this.resetForm.status === 'VALID') {
      this.changePassword();
    } else if (this.multiBrokerloginType === MultiBrokerLoginTypesEnum.SIMULADOR) {
      if (this.isAuthenticationBroker && this.brokerConnected !== 'SIMULATOR') {
        this.loading = false;
        return;
      }
      this._configService.setStopValidUser(true);
      const brokers = this._configService.getConfigMultibroker();
      if (!this.isAuthenticationBroker || (this.isAuthenticationBroker && brokers)) {
        this.loginSimulator();
      } else {
        this._configService.systemNotificationMessage('', Constants.BROKER_SIDE_BAR_SIMULATOR, Constants.ALERT_TYPE.info);
        this.loading = false;
      }
    } else if (this.multiBrokerloginType === MultiBrokerLoginTypesEnum.MULTIBROKER && this.authForm.status === 'VALID') {
      this._configService.setStopValidUser(true);
      this.loginMultibroker();
    } else {
      this.loading = false;
    }
  }

  loginSimulator() {
    this.loading = true;
    this.removeConfigMultibroker();
    const _userMarketData = this._configService.getUserMarketData();
    this._authenticationService.brokerServiceLogin(_userMarketData.login, _userMarketData.login, null)
      .subscribe((data: any) => {
        if (data && data.isAuthenticated === 'N') {
          this._authenticationService.clientRegisterSimulator(_userMarketData.login, _userMarketData.login)
            .subscribe(res => {
              if (res && (res.success === 'true' || res.success === true)) {
                setTimeout(() => { this.send(); }, 3000);
              } else {
                this.loading = false;
                this._configService.systemNotificationMessage('', Constants.BROKER_MSG012, Constants.ALERT_TYPE.error);
              }
              this.loading = false;
            }, error => {
              this.loading = false;
              this._configService.systemNotificationMessage('', Constants.BROKER_MSG012, Constants.ALERT_TYPE.error);
            });
        } else if (data && data.isAuthenticated === 'Y') {
          if (data.authenticationReqId.split(',').length > 1) {
            data.authenticationReqId = data.authenticationReqId.split(',')[0];
          }
          this._configService.setTokenNegotiation(data.tokenNegotiation);
          this.closeClick();
          this._configService._authHbLogged.next(true);
          this._configService.setHbLoginTypeEnable(Constants.LOGIN_S);
          this._scktLoginDuplicatedService._authLoginDuplicated.next(LoginDuplicatedEnum.ONLINE_DIFUSION);
          const typeLoginHB = Constants.COOKIE_HB_TYPE_SIMULATOR;
          this._configService.setBrokerAccount(data.authenticationReqId, typeLoginHB);
          this._configService._authHbLoginType.next(Number(typeLoginHB));
          const brokerTemp = this.multiBrokerloginType === MultiBrokerLoginTypesEnum.MULTIBROKER ? this.authForm.value.broker.usersBrokerName : this.typeRadioSelected.id;
          this._configService.setBrokerConnected(brokerTemp);
        } else if (data && data.token) {
          this.setCookiesBrokers(data, true);
        } else {
          this._configService.systemNotificationMessage('', Constants.BROKER_MSG012, Constants.ALERT_TYPE.error);
          this._configService._authHbLogged.next(false);
          this.loading = false;
        }
      }, () => {
        this._configService.systemNotificationMessage('', Constants.BROKER_MSG012, Constants.ALERT_TYPE.error);
        this.loading = false;
      });
  }

  loginMultibroker() {
    const _user = {
      username: this.authForm.value.username,
      password: this.authForm.value.password,
      broker: this.authForm.value.broker.usersBrokerName
    };
    this._authenticationService.loginBroker(_user.username, _user.password, _user.broker)
      .subscribe((data: any) => {
        if (data.code || data === 'PASSWORD_EXPIRED' || data === 'INVALID_CREDENTIALS' || data === 'INVALID_MESSAGE') {
          if (data.codeMessage === 'UNAUTHORIZED') {
            if (data && (Number(data.code) === 3 || Number(data.code) === 9)) {
              this._configService.systemNotificationMessage('', data.message, Constants.ALERT_TYPE.info);
              this.isResetPassword = true;
              this.subTitleExpiredPassword = data.message;
            } else if (data.message) {
              this._configService.systemNotificationMessage('', data.message, Constants.ALERT_TYPE.error);
            } else {
              this._configService.systemNotificationMessage('', Constants.MSG_LOGIN_MSG002, Constants.ALERT_TYPE.error);
            }
            this.authForm.controls['username'].setErrors({ 'customError': true });
            this.authForm.controls['password'].setErrors({ 'customError': true });
          } else {
            const messageTemp = data === 'PASSWORD_EXPIRED' ? Constants.MSG_LOGIN_MSG009 : data === 'INVALID_CREDENTIALS' ? Constants.MSG_LOGIN_MSG002 :
              data === 'INVALID_MESSAGE' ? Constants.MSG_LOGIN_MSG010 : data.message;
            this._configService.systemNotificationMessage('', messageTemp, Constants.ALERT_TYPE.error);
          }
          this.loading = false;
          return;
        } else {
          this._configService.setCookieUserLoginMultiBroker(_user.broker, _user.username);
          this.setCookiesBrokers(data, false);
        }
      }, error => {
        this.loading = false;
        const messageError = error && error.message ? error.message : Constants.BROKER_MSG012;
        this._configService.systemNotificationMessage('', messageError, Constants.ALERT_TYPE.error);
      });
  }

  setCookiesBrokers(data, isSimulator) {
    setTimeout(() => {
      this._configService.systemNotificationMessage('', Constants.TEXT_RECCONECT_SOCKET_ONLINE, Constants.ALERT_TYPE.info);
      this._configService.setTokenApi(data.token);
      const typeLoginHB = isSimulator ? Constants.COOKIE_HB_TYPE_SIMULATOR : Constants.COOKIE_HB_TYPE_CEDRO;
      this._configService.setBrokerAccount(data.accountNumber, typeLoginHB);
      this._configService.setTokenApi(data.token);
      this._configService.setToken(data.tokenWS);
      this._configService.setTokenNegotiation(data.tokenWS);
      this._configService.setTokenGraphic(data.tokenWsGraphic);
      this._configService.setHbAccount(data.accountNumber);
      this._configService.setTokenLastRefreshed(AppUtils.getDateTimeLocaleFormat(new Date((new Date()).getTime())));
      this._configService.setTokenExpiration(AppUtils.getDateTimeLocaleFormat(new Date((new Date()).getTime() + Number(this._configService.getTimerTokenExpiration()))));
      this._configService.setGuidUser(data.guidUser);
      this._configService.setHba(data.guidUser, '0');
      this._authService.setUserLogged(data.accountNumber);
      this._configService.deleteBrokerAccountSelectedTransition();
      this._configService._authHbLogged.next(true);
      this._configService.setHbLoginTypeEnable(Constants.LOGIN_S);
      this._configService.setHideMessageDisconectSocket('true');
      this._socket.disconnect(true);
      this._scktLoginDuplicatedService._authLoginDuplicated.next(LoginDuplicatedEnum.ONLINE_DIFUSION);
      const brokerTemp = this.multiBrokerloginType === MultiBrokerLoginTypesEnum.MULTIBROKER ? this.authForm.value.broker.usersBrokerName : this.typeRadioSelected.id;
      this._configService.setBrokerConnected(brokerTemp);
    }, 1000);
  }

  changePassword() {
    const _user = {
      username: this.authForm.value.username,
      password: this.authForm.value.password,
      newPassword: this.resetForm.value.newPassword
    };
    if (_user.username && _user.password && _user.newPassword) {
      this._authenticationService.difusionChangePassword(_user.username, _user.password, _user.newPassword, true)
        .subscribe(res => {
          if (res && (res.success === 'true' || res.status === true || Number(res.userStatus) === 5)) {
            this._configService.systemNotificationMessage('', Constants.MSG_RECOVER_PASSWORD_MULTIBROKER, Constants.ALERT_TYPE.success);
            this.authForm.value.password = this.resetForm.value.newPassword;
            this.loginMultibroker();
          } else {
            if (res && res.message) {
              this._configService.systemNotificationMessage('', res.message, Constants.ALERT_TYPE.error);
            } else if (res && res.userStatusText) {
              this._configService.systemNotificationMessage('', res.userStatusText, Constants.ALERT_TYPE.error);
            } else if (res && (!res.success || res.success === 'false')) {
              this._configService.systemNotificationMessage('', Constants.MSG_LOGIN_MSG008, Constants.ALERT_TYPE.error);
            } else {
              this._configService.systemNotificationMessage('', Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
            }
            this.loading = false;
          }
        }, () => {
          this._configService.systemNotificationMessage('', Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
          this.loading = false;
        });
    } else {
      this._configService.systemNotificationMessage('', Constants.MSG_LOGIN_MSG001, Constants.ALERT_TYPE.warn);
      this.loading = false;
      return false;
    }
  }

  showForgotPassword() {
    this.isResetPassword = false;
    this.isForgotPassword = true;
  }

  forgotPassword() {
    const email = this.forgotForm.value.email;
    if (email) {
      this._authenticationService.recoverPassword(email, Constants.FORGOT_TYPE_01, true)
        .subscribe(res => {
          if (res && ((res.success === 'true' || res.success === true) || (this._configService.isLoginTypeWSO2() && res._isScalar !== false))) {
            this._configService.systemNotificationMessage('', Constants.BROKER_MSG013, Constants.ALERT_TYPE.success);
          } else if (res && (res.success === 'false' || res.success === false) && res.message) {
            this._configService.systemNotificationMessage('', res.message, Constants.ALERT_TYPE.error);
          } else {
            this._configService.systemNotificationMessage('', Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
          }
          this.loading = false;
        }, (errorResponse) => {
          const res = errorResponse.error;
          if (!!res.message) {
            this._configService.systemNotificationMessage('', res.message, Constants.ALERT_TYPE.error);
          } else {
            this._configService.systemNotificationMessage('', Constants.MSG_LOGIN_MSG003, Constants.ALERT_TYPE.error);
          }
          this.loading = false;
        });
    }
  }

  getContextInfoUser() {
    this.loading = true;
    this.brokeragePartners = [];
    const _userMarketData = this._configService.getUserMarketData();
    if (_userMarketData) {
      this._authServer.iCedroServices.contextInfoUser(_userMarketData.login, _userMarketData.password)
        .subscribe(res => {
          if (res && res.shadow && res.shadow.shadowLogin === _userMarketData.login && res.usersBroker.length > 0) {
            res.usersBroker.forEach(element => {
              if (element && element.usersBrokerName && element.usersBrokerFaced && element.usersBrokerService && element.usersBrokerName !== WhitelabelBrokerEnum.CEDRO) {
                const brokerTemp = new ContextInfoUser();
                brokerTemp.usersBrokerViewName = element.usersBrokerName ? element.usersBrokerName.replace('_', ' ') : element.usersBrokerName;
                brokerTemp.usersBrokerName = element.usersBrokerName;
                brokerTemp.usersBrokerFaced = element.usersBrokerFaced;
                brokerTemp.usersBrokerService = element.usersBrokerService ? element.usersBrokerService.replace('https', 'wss').replace('http', 'ws') : element.usersBrokerService;
                if (brokerTemp.usersBrokerService && brokerTemp.usersBrokerService.indexOf('/ws')) {
                  brokerTemp.usersBrokerService = brokerTemp.usersBrokerService + '/ws';
                }
                brokerTemp.usersBrokerImamge = element.usersBrokerName
                  ? './assets/images/broker/BROKER_' + element.usersBrokerName.toUpperCase() + '.png' : element.usersBrokerName;
                let brokerDouble;
                if (this.brokeragePartners && this.brokeragePartners.length > 0) {
                  brokerDouble = this.brokeragePartners.find(x => x.usersBrokerName === element.usersBrokerName);
                }
                if (!brokerDouble && this.brokeragePartners) {
                  this.brokeragePartners.push(brokerTemp);
                }
              }
            });
          } else {
            this._configService.systemNotificationMessage('', res && res.code === 2 ? Constants.BROKER_MSG007 : Constants.BROKER_MSG006, Constants.ALERT_TYPE.error);
            this.loading = false;
          }
          AppUtils.orderObjectAsc(this.brokeragePartners, 'usersBrokerName');
          const brokerSelected = this._configService.getConfigMultibroker();
          if (brokerSelected) {
            this.multiBrokerSelected = this.brokeragePartners.find(x => x.usersBrokerName === brokerSelected.usersBrokerName);
          } else {
            this.multiBrokerSelected = this.brokeragePartners.find(x => x.usersBrokerName === this._configService.getBroker());
          }
          setTimeout(() => {
            this.setUsernameBrokerSelected();
          }, 0);
          this.loading = false;
        }, () => {
          this._configService.systemNotificationMessage('', Constants.BROKER_MSG006, Constants.ALERT_TYPE.error);
          this.loading = false;
        });
    }
  }

  setConfigMultiBroker() {
    if (this.multiBrokerSelected) {
      this.setUsernameBrokerSelected();
      this._configService.setStopValidUser(true);
      this._configService.setConfigMultibroker(this.multiBrokerSelected);
      this._configService.writeLog(this.multiBrokerSelected, 'LOGIN > Broker Selecionado: ');
    }
  }

  setUsernameBrokerSelected() {
    const usersCookieMultiBroker = this._configService.getCookieUserLoginMultiBroker();
    let userTemp;
    if (usersCookieMultiBroker && usersCookieMultiBroker.brokers && usersCookieMultiBroker.brokers.length > 0 &&
      this.multiBrokerSelected && this.multiBrokerSelected.usersBrokerName) {
      userTemp = usersCookieMultiBroker.brokers.find(x => x.broker === this.multiBrokerSelected.usersBrokerName);
    }
    this.authForm.get('username').setValue(userTemp ? userTemp.username : '');
    this.authForm.get('password').setValue('');
  }

  togglePassword() {
    this.showpassword = !this.showpassword;
  }

  togglePasswordConfirm() {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  validChar(e) {
    if (AppUtils.validCharSystem(e)) {
      this._configService.systemNotificationMessage('', 'Caracter (' + e.key + ') inválido.', Constants.ALERT_TYPE.warn);
      return false;
    }
  }

  validatorPassword() {
    if (this.resetForm.value.password !== this.resetForm.value.newPassword) {
      this.resetForm.controls['password'].setErrors({ 'customError': true });
      this.resetForm.controls['newPassword'].setErrors({ 'customError': true });
    } else {
      this.resetForm.controls['password'].setErrors(null);
      this.resetForm.controls['newPassword'].setErrors(null);
    }
  }

  validatorPassword2() {
    if (this.resetForm.value.newPassword) {
      if (this.resetForm.value.password !== this.resetForm.value.newPassword) {
        this.resetForm.controls['password'].setErrors({ 'customError': true });
        this.resetForm.controls['newPassword'].setErrors({ 'customError': true });
      } else {
        this.resetForm.controls['password'].setErrors(null);
        this.resetForm.controls['newPassword'].setErrors(null);
      }
    }
    if (this.resetForm.value.password) {
      this.complexyPassoword(this.resetForm.value.password);
    } else {
      this.passwordComplexyLength = false;
      this.passwordComplexyNumber = false;
      this.passwordComplexySpecial = false;
      this.passwordComplexyLetterUp = false;
      this.passwordComplexyLetterDown = false;
    }
  }

  complexyPassoword(value) {
    if (value && value !== '') {
      const passwordComplexyLengthTemp = new RegExp('^(?=.{8,})').test(value);
      const passwordComplexySpecialTemp = new RegExp('^(?=.*[#$^+=!*()@%&])').test(value);
      const passwordComplexyNumberTemp = new RegExp('^(?=.*[0-9])').test(value);
      const passwordComplexyLetterUpTemp = new RegExp('^(?=.*[A-Z])').test(value);
      const passwordComplexyLetterDownTemp = new RegExp('^(?=.*[a-z])').test(value);
      if (passwordComplexyLengthTemp) {
        this.passwordComplexyLength = true;
      } else {
        this.passwordComplexyLength = false;
      }
      if (passwordComplexySpecialTemp) {
        this.passwordComplexySpecial = true;
      } else {
        this.passwordComplexySpecial = false;
      }
      if (passwordComplexyNumberTemp) {
        this.passwordComplexyNumber = true;
      } else {
        this.passwordComplexyNumber = false;
      }
      if (passwordComplexyLetterUpTemp) {
        this.passwordComplexyLetterUp = true;
      } else {
        this.passwordComplexyLetterUp = false;
      }
      if (passwordComplexyLetterDownTemp) {
        this.passwordComplexyLetterDown = true;
      } else {
        this.passwordComplexyLetterDown = false;
      }
    }
  }

}
